/*
 * Copyright (c) 2023, tuanchauict
 */

package mono.shape.extra

/**
 * A sealed interface for extra attributes for shapes
 */
sealed class ShapeExtra

object NoExtra : ShapeExtra()
